import './button.css';

export const Button = ({ variant, size, customBorder, children, ...props }) => {
  const buttonVariants = {
    primary: "btn primary-button",
    secondary: "btn secondary-button",
    disabled: "btn disabled-button",
    outline: "btn outline-primary-button",
    outlineSecondary: "btn outline-secondary-button",
    link: "btn link",
  };

  const getSize = () => {
    switch (size) {
      case "sm":
        return "col-md-4";
      case "md":
        return "col-md-6";
      case "lg":
        return "col-md-12";
      default:
        return "";
    }
  };

  return (
    <button
      className={`${buttonVariants[variant]} ${getSize()} ${customBorder}`}
      {...props}
    >
      {children}
    </button>
  );
};
